import React from 'react';
import { Content, Row, Col, Title, Button, HtmlContent } from 'components';
import { SideMenu } from 'routes/main.routes/Mypage/components';
import { csMenu } from '../csMenu';
import Formatter from 'utils/Formatter';

const HelpNoticeDetailsPresenter = (props) => {
  /* ===== Props ===== */
  const { navigate, notice, screenSize } = props;

  /* ===== VARIABLE ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    button: {
      padding: '10px 29px',
      backgroundColor: 'transparent',
      border: '1px solid #ddd',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '10px 29px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
    },
    notice: {
      width: '100%',
      padding: '32px 0',
      borderBottom: '1px solid #ddd',
      cursor: 'pointer',
      fontSize: 16,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: screenSize >= 768 ? 'unset' : 'column',
      rowGap: 20,
    },
  };

  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={2}></Col>
        <Col x={0} md={4}>
          <SideMenu menu={csMenu} title="고객센터" />
        </Col>
        <Col x={24} md={16}>
          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
          >
            <div style={styles.titleLayout}>
              <Title style={styles.title}>공지사항</Title>
            </div>
            <div style={styles.notice}>
              <div
                style={{
                  display: 'flex',
                  alignItems: screenSize >= 768 ? 'center' : 'start',
                  flexDirection: screenSize >= 768 ? 'unset' : 'column',
                  rowGap: 20,
                }}
              >
                {/* <div
                  style={{
                    // width: 40,
                    marginRight: 24,
                    fontWeight: 700,
                  }}
                >
                  8
                </div> */}
                <span
                  style={{
                    border: '1px solid var(--black-color)',
                    padding: '2px 8px',
                    marginRight: '8px',
                  }}
                >
                  공지
                </span>
                {notice?.notice_name}
              </div>
              <div>
                {Formatter.unixToDate(notice?.created_at, 'YYYY.MM.DD')}
              </div>
            </div>
            <div
              style={{
                padding: screenSize >= 768 ? '40px 24px' : ' 20px 0',
                webkitLineClamp: 'none',
                borderBottom: '1px solid #ddd',
              }}
            >
              <HtmlContent content={notice?.notice_content} />
            </div>
            <div
              maxWidth={'100%'}
              padding={0}
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin:
                  screenSize >= 768 ? '100px auto 80px' : '60px auto 20px',
              }}
            >
              <Button
                style={{
                  width: '22%',
                  minWidth: 100,
                  padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                  fontSize: screenSize >= 768 ? 16 : 14,
                  fontWeight: 700,
                  borderRadius: '2px',
                  backgroundColor: 'var(--white-color)',
                  color: 'var(--black-color)',
                  border: '1px solid var(--black-color)',
                }}
                onClick={() => navigate(`/cs/notice`)}
              >
                목록
              </Button>
            </div>
          </Content>
        </Col>
        <Col x={0} md={2}></Col>
      </Row>
    </Content>
  );
};

export default HelpNoticeDetailsPresenter;
